import axios from 'axios'
import store from 'store'
import { notification } from 'antd'

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  paramsSerializer: (params) => new URLSearchParams(params).toString().replace(/\+/g, '%20'),
})

apiClient.interceptors.request.use((request) => {
  const accessToken = store.get('accessToken')
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }
  return request
})

apiClient.interceptors.response.use(undefined, (error) => {
  const { response } = error
  const { data, status } = response || {}

  if (status === 401 || status === 403) {
    notification.error({
      message: data?.errors
        ? data.errors[Object.keys(data.errors)[0]]
        : data.message || 'Session Expired',
      key: 'session_expired',
    })
    store.remove('accessToken')
    // Dispatch logout action if using redux
    if (window.storeRedux) {
      window.storeRedux.dispatch({ type: 'user/LOGOUT' })
    }
    if (window.location.pathname !== '/auth/login') {
      const next = encodeURIComponent(window.location.pathname + window.location.search)
      window.location.href = `/auth/login?next=${next}`
    }
    return Promise.reject(error)
  }

  if (data) {
    notification.warning({
      message: data.errors ? data.errors[Object.keys(data.errors)[0]] : data.message,
    })
  }
  return Promise.reject(error)
})

export default apiClient
